export const products = [
  /* --------------------------------------------------------------------------
     NEW CATEGORY 1 — CUSTOM ACOUSTIC & WEATHERPROOF ENCLOSURE
  --------------------------------------------------------------------------- */
  {
    category: "Custom Acoustic & Weatherproof Enclosure",
    slug: "custom-acoustic-enclosures",
    type: "direct",
    categoryId: "CAT-CUST-ENCL",
    image: {
      url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_01.webp",
      alt: "Custom-engineered acoustic and weatherproof containers.",
    },
    description:
      "High-performance sound-attenuated and weatherproof housing for critical power infrastructure.",
    items: [
      {
        id: "AGP-CONT-DC-CUSTOM",
        name: "Custom Acoustic & Weatherproof Enclosure",
        manufacturerPartNumber: "Custom-DC-GEN-ENCL",
        AGPPartNumber: "AGP-CONT-XXX",
        Make: "ESI-Art GenPower Solutions Ltd",
        images: [
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_02.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_03.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container_ARC_ESI_04.webp",
          "https://media.arcengltd.com/facility-images/Hamriyah_Facility_03.webp",
          "https://media.arcengltd.com/facility-images/Sajja_Facility_04.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container Layout_ARC_ESI_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Container Layout_ARC_ESI_02.webp",
        ],
        shortDescription:
          "Custom-engineered acoustic and weatherproof containers for data center standby power, rated for critical sound levels and hazardous environments.",
        description:
          "These heavy-duty generator containers are custom-engineered to provide a secure, climate-controlled environment for mission-critical data center power systems. Designed to meet the highest standards of reliability, our containers feature advanced acoustic insulation to achieve 'critical' sound levels, making them suitable for urban or noise-sensitive environments. Each module is built following rigorous manufacturing procedures and quality inspections. The integrated gas detection and fire suppression systems (CO2 or Water Mist) provide automated protection, while the IP-rated construction ensures that internal electronics remain protected from external contaminants. The structural design is analyzed for client-specific load requirements, ensuring durability for both onshore and offshore applications.",
        uses: [
          "Mission-critical data center standby power protection",
          "Urban noise-sensitive power installations",
          "Hazardous environment (Zone II ATEX) power housing",
          "Offshore and Onshore heavy-duty engine containment",
          "High-risk zones requiring certified fire-rated protection",
        ],
        productRange: [
          {
            category: "Standard & Custom Containers",
            options:
              "Standard ISO & High Cube configurations (20ft, 30ft, & 40ft)",
          },
          {
            category: "Acoustic Enclosures",
            options: "Custom-built sound-attenuated for Off-Shore & On-Shore",
          },
          {
            category: "Specialized Safety Units",
            options: "Fully certified Fire Rated Enclosures",
          },
          {
            category: "Compact Solutions",
            options: "Drop Over Canopies for quick installation",
          },
          {
            category: "Critical Infrastructure",
            options: "Dedicated Data Center Acoustic Solutions",
          },
          {
            category: "Integration Services",
            options: "Professional Engine & Alternator Coupling",
          },
        ],
        details: {
          EnvironmentalRating: "Weatherproof (Enclosure) / IP rated",
          AcousticPerformance: "65 - 85 dBA @ 1 Meter (Customizable)",
          FireSuppression: "Optional CO2 / Water Mist / Integrated Detection",
          ElectricalCompliance: "Optional Zone II ATEX / IECEx Fittings",
          FuelSystem: "Single or Double Wall Base Tank",
          StructuralStandard: "Client-Specific Analysis (Seismic/Wind rated)",
          Inspections: "Third-Party Certification (ABS, Lloyd’s, etc.)",
        },
      },
    ],
  },

  /* --------------------------------------------------------------------------
     NEW CATEGORY 2 — MODULAR E-HOUSE & E-POD SOLUTIONS
  --------------------------------------------------------------------------- */
  {
    category: "Modular E-House & E-POD Solutions",
    slug: "modular-e-house",
    type: "direct",
    categoryId: "CAT-EHOUSE",
    image: {
      url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_01.webp",
      alt: "Prefabricated modular substation for power distribution.",
    },
    description:
      "Complete, plug-and-play power distribution centers for remote and demanding locations.",
    items: [
      {
        id: "AGP-EHOUSE-MOD-001",
        name: "Modular E-House & E-POD Solutions",
        manufacturerPartNumber: "MOD-EHOUSE-OS-OFF",
        AGPPartNumber: "AGP-PWR-EHOUSE",
        Make: "ESI-Art GenPower Solutions Ltd",
        images: [
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_02.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_03.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/E-House E-Pod_ARC_ESI_04.webp",
        ],
        shortDescription:
          "A complete, plug-and-play power distribution center. Our customized E-House modules deliver reliable power infrastructure to the most remote and demanding locations.",
        description:
          "Our Electrical Houses (E-Houses) and E-PODs are prefabricated, modular substations designed to house critical electrical and automation equipment. Moving away from traditional brick-and-mortar substations, these steel-structure solutions offer a smarter, faster way to deploy power. \n\nEngineered for both Onshore and Offshore applications, our modules provide a controlled environment for sensitive equipment such as MV/LV Switchgears, Variable Frequency Drives (VFDs), and Control Panels. We offer a true One-Stop Solution: we handle the structural manufacturing, system integration (HVAC, F&G, Lighting), and factory testing before the unit ever reaches your site.",
        uses: [
          "Rapid deployment of power infrastructure in remote sites",
          "Offshore platform power distribution modules",
          "Industrial plant substation upgrades with optimized footprint",
          "Controlled environments for sensitive MV/LV Switchgear",
          "Mobile power solutions for mining and oil & gas fields",
        ],
        productRange: [
          {
            category: "Climate Control",
            options:
              "Heavy-duty HVAC systems for extreme desert or marine heat",
          },
          {
            category: "Safety Systems",
            options: "Integrated Fire & Gas (F&G) detection and suppression",
          },
          {
            category: "Electrical & MEP",
            options:
              "Complete internal lighting, small power, and auxiliary panels",
          },
          {
            category: "Structural Integrity",
            options:
              "IP55 rated steel enclosures with raised flooring and motorized louvers",
          },
          {
            category: "Scalability",
            options: "Modular coupling of 20ft/40ft ISO High Cube units",
          },
        ],
        successStories: [
          {
            client: "Saudi Aramco (KSA)",
            project:
              "Custom-built substations with HVAC, F&G, and raised flooring",
          },
          {
            client: "Rolls-Royce Solutions (KSA)",
            project: "4x MV Switchgear containers and 14x Custom Enclosures",
          },
          {
            client: "Bahrain International Airport",
            project: "E-House with full auxiliary integration",
          },
          {
            client: "Drydocks World (Dubai)",
            project:
              "Modularized containers for marine applications with full FAT",
          },
        ],
        downloads: [
          {
            name: "Technical Specifications",
            url: "#",
          },
        ],
        details: {
          ModuleType: "ISO Containerized (20ft/40ft) or Custom Steel Building",
          Application: "Onshore (Desert/Industrial) & Offshore (Marine)",
          ProtectionRating: "IP55 / NEMA 4X",
          FireSafety: "Integrated Smoke/Heat Detection & Gas Suppression",
          Flooring: "Anti-static Raised Flooring or Chequered Plate",
          Cooling: "Redundant HVAC Units (Roof or Wall Mounted)",
          Certifications: "Factory Acceptance Tested (FAT) prior to shipping",
        },
      },
    ],
  },

  /* --------------------------------------------------------------------------
     NEW CATEGORY 3 — PUMP SKIDS & CHEMICAL INJECTION PACKAGES
  --------------------------------------------------------------------------- */
  {
    category: "Pump Skids & Chemical Injection Packages",
    slug: "pump-skids-injection",
    type: "direct",
    categoryId: "CAT-PUMP-SKID",
    image: {
      url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_01.webp",
      alt: "Modular pump skid for oil and gas intervention.",
    },
    description:
      "Precision fluid delivery and well intervention solutions for the global energy sector.",
    items: [
      {
        id: "AGP-PUMP-SKID-003",
        name: "Pump Skids & Chemical Injection Packages",
        manufacturerPartNumber: "PUMP-INJ-OG-MOD",
        AGPPartNumber: "AGP-FLUID-INJ",
        Make: "ESI-Art GenPower Solutions Ltd",
        images: [
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_01.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_02.webp",
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/product-images/Pump Skids and Chemical Injection_ARC_ESI_03.webp",
        ],
        shortDescription:
          "Engineered for the demanding Oil & Gas sector, our modular Pump Skids and Injection Packages provide precise fluid delivery and well intervention solutions.",
        description:
          "Our Pump Skids and Injection Packages are specialized equipment systems designed to support critical operations in various industries, with a primary focus on Oil & Gas Operations. These units are essential for well intervention and stimulation processes. \n\nEach package is engineered as a fully integrated solution, combining high-pressure pumping capabilities with precise chemical dosing systems. Whether you require a standalone injection unit or a complex system integrated with coiled tubing operations, our skids are built to deliver fluids and chemicals into the wellbore safely and efficiently. Designed for mobility and rapid deployment, our systems come mounted on heavy-duty structural steel skids, ensuring they can be easily transported and lifted into position on crowded drill sites or platforms.",
        uses: [
          "Oil & Gas well stimulation and productivity improvement",
          "Injection of corrosion inhibitors and biocides",
          "Downhole fluid delivery for well intervention",
          "Continuous fluid delivery support for Coiled Tubing units",
          "High-pressure chemical dosing in harsh environments",
        ],
        productRange: [
          {
            category: "System Design",
            options:
              "Integrated pumping, metering, and control in a single compact unit",
          },
          {
            category: "Intervention Capability",
            options:
              "Engineered for tasks such as well stimulation and downhole delivery",
          },
          {
            category: "Precision Injection",
            options:
              "Accurate dosing systems for controlled chemical flow rates",
          },
          {
            category: "Modular Mounting",
            options:
              "Robust frames with integrated lifting points for easy transport",
          },
          {
            category: "Materials",
            options:
              "High-grade stainless steel components to resist extreme corrosion",
          },
        ],
        downloads: [
          {
            name: "Technical Specifications",
            url: "#",
          },
        ],
        details: {
          PrimaryApplication:
            "Well Intervention, Stimulation, Chemical Injection",
          MaxOperatingPressure: "Custom (up to 10,000 PSI / 15,000 PSI)",
          SkidMaterial: "Heavy-Duty Carbon Steel (Galvanized or Painted)",
          PipingMaterial: "Stainless Steel (316L) / Duplex / Inconel",
          ControlSystem: "Manual / PLC Automated / Remote Operation",
          Compliance: "API Standards / DNV Certified Frames (Offshore)",
        },
      },
    ],
  },

  /* --------------------------------------------------------------------------
     NEW CATEGORY 4 — SELF-BUNDED FUEL STORAGE
  --------------------------------------------------------------------------- */
  {
    category: "Self-Bunded Fuel Storage",
    slug: "fuel-storage-tanks",
    type: "direct",
    categoryId: "CAT-FUEL-STORAGE",
    image: {
      url: "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
      alt: "Double-walled fuel storage tanks.",
    },
    description:
      "Premium Acecube 110% self-bunded tanks for safe, compliant fuel storage and transport.",
    items: [
      {
        id: "AGP-FUEL-ACECUBE-004",
        name: "Self-Bunded Fuel Storage",
        manufacturerPartNumber: "AC-SB-FUEL-SERIES",
        AGPPartNumber: "AGP-FUEL-TANKS",
        Make: "Acecube / ESI-Art GenPower Solutions Ltd",
        images: [
          "https://media.arcengltd.com/cdn-cgi/image/width=700,height=500,fit=pad,background=white,format=auto,quality=auto/arc_placeholder.webp",
        ],
        shortDescription:
          "Premium range of Acecube fuel tanks offering 110% self-bunded (double-walled) design for safe, compliant onsite fuel storage and transport in any environment.",
        description:
          "Our premium range of Acecube fuel tanks offers the ultimate solution for safe onsite fuel storage and transport. Featuring a 110% self-bunded (double-walled) design, these tanks ensure zero environmental contamination while maximizing durability and ease of use.\n\nFrom construction sites to offshore platforms, these tanks are engineered with a unique Hex-Corner Design for added structural strength and impact resistance. The smart engineering includes a removable inner tank for easy maintenance and a 'Letter Box' opening that allows fuel hoses to run while the cabinet remains securely locked and pressurized. Built to be stackable (up to 3-high empty) and easily maneuverable via bi-directional forklift pockets.",
        uses: [
          "Secure onsite fuel storage for construction and mining",
          "Auxiliary fuel supply for standby power generators",
          "DNV 2.7-1 certified fuel transport for offshore platforms",
          "Agricultural and industrial bulk fuel management",
          "Remote site refueling with integrated pump dispensing",
        ],
        productRange: [
          {
            category: "Standard Series",
            options:
              "Industry standard for general construction (950L - 10,000L)",
          },
          {
            category: "Versatile Series",
            options:
              "Enhanced life with galvanized hatch lids and corners (950L - 10,000L)",
          },
          {
            category: "All-Terrain Series",
            options:
              "Fully galvanized frame for extreme rust protection (Up to 60,000L)",
          },
          {
            category: "Offshore Series",
            options:
              "DNV 2.7-1 Certified with heavy-duty side frames (950L - 3,000L)",
          },
          {
            category: "Bulk / ISO Solutions",
            options:
              "CSC regulated containers with bund leak detection (20kL, 27kL, 60kL)",
          },
        ],
        downloads: [
          {
            name: "Technical Specifications",
            url: "#",
          },
        ],
        details: {
          Certifications: "UL 142, ULC S-601, UN/ADR 31AY, BS 799",
          EnvironmentalCompliance: "PPG2 Compliant (110% Spill Prevention)",
          StructuralDesign: "Hex-Corner Design with Stacking Corners",
          LidSystem: "Pitched Outer Lid (Anti-rain accumulation)",
          Security: "Lockable Primary & Secondary Hatches",
          PumpCompatibility:
            "Mounting brackets included; Optional AC/DC Dispenser",
          SafetyFeatures: "Emergency Vents & Optional Bund Leak Detector",
          Handling: "Bi-directional Forklift Pockets & Corner Lifting Lugs",
        },
      },
    ],
  },
];
